import PublicSchoolSubtypeForm from './PublicSchoolSubtypeForm.component';

export default PublicSchoolSubtypeForm;